import { Vessel, PartInstance } from '../core/vessel/vessel'

/**
 * Un progetto: il veicolo piu quello che serve all'editor e non alla fisica.
 *
 * I gruppi di simmetria vivono QUI e non in `core/`: al simulatore non
 * importa che quattro alette siano state messe insieme, ma all'editor si —
 * spostarne una deve spostarle tutte.
 */
export interface Design {
  readonly nome: string
  readonly vessel: Vessel
  /** id del gruppo → id delle parti che si muovono e si cancellano insieme */
  readonly symmetryGroups: Record<string, string[]>
}

export const designVuoto = (nome = 'Senza nome'): Design => ({
  nome,
  vessel: { rootId: '', parts: [] },
  symmetryGroups: {},
})

export function clonaDesign(d: Design): Design {
  return {
    nome: d.nome,
    vessel: { rootId: d.vessel.rootId, parts: d.vessel.parts.map((p): PartInstance => ({ ...p })) },
    symmetryGroups: Object.fromEntries(Object.entries(d.symmetryGroups).map(([k, v]) => [k, [...v]])),
  }
}

export const daVeicolo = (vessel: Vessel, nome: string): Design => ({
  nome, vessel, symmetryGroups: {},
})

/** Il gruppo di simmetria a cui appartiene una parte, se ce n'e uno. */
export function gruppoDi(d: Design, partId: string): string | null {
  for (const [g, membri] of Object.entries(d.symmetryGroups)) {
    if (membri.includes(partId)) return g
  }
  return null
}

/** Le parti che si muovono insieme a questa: se stessa, se non e in un gruppo. */
export function compagne(d: Design, partId: string): string[] {
  const g = gruppoDi(d, partId)
  return g ? [...d.symmetryGroups[g]!] : [partId]
}
